import type { LogsEvent } from '@datadog/browser-logs'

// Auth0's implicit flow returns the tokens in the URL hash (/#access_token=…&id_token=…).
// Any log sent before the router guard rewrites the URL would otherwise carry them to Datadog.
const SECRET_PARAMS = ['access_token', 'id_token', 'refresh_token']

const REDACTED = '[REDACTED]'

const SECRET_PARAM_PATTERN = new RegExp(
  `((?:^|[?#&])(?:${SECRET_PARAMS.join('|')})=)[^&#\\s"']*`,
  'g',
)

// A JWT anywhere else, e.g. in an error message or stack.
const JWT_PATTERN = /eyJ[\w-]+\.[\w-]+\.[\w-]+/g

export const scrubSecrets = (value: string): string =>
  value
    .replace(SECRET_PARAM_PATTERN, `$1${REDACTED}`)
    .replace(JWT_PATTERN, REDACTED)

const scrub = (value: string | undefined): string | undefined =>
  value === undefined ? undefined : scrubSecrets(value)

export const scrubDatadogLog = (log: LogsEvent): void => {
  log.message = scrubSecrets(log.message ?? '')

  if (log.view) {
    log.view.url = scrubSecrets(log.view.url)
    log.view.referrer = scrub(log.view.referrer)
  }

  if (log.http) {
    log.http.url = scrubSecrets(log.http.url)
  }

  if (log.error) {
    log.error.message = scrub(log.error.message)
    log.error.stack = scrub(log.error.stack)
  }
}

export default scrubDatadogLog
